<template>
  <label
    :for="name"
    :class="$cn('block text-xs font-medium text-supplement', ui?.label)"
  ><slot /></label>
</template>

<script setup lang="ts">
import type { ClassValue } from 'clsx'

const props = defineProps<{
  name?: string
  ui?: Partial<{
    label: ClassValue
  }>
}>()
</script>
